module.exports = __webpack_public_path__ + "static/media/Component-2.e51eb5de.svg";